export default "__VITE_ASSET__BZoGaxgm__"